import { Card, CardProps, type Theme } from "@mui/material";
import type { SystemStyleObject } from "@mui/system";

/** Fixed width for `StyledCardRoot` (capacity cards, etc.). */
export const ADMIN_STYLED_CARD_WIDTH_PX = 380;

/** Fixed width for department cards (narrower than company cards). */
export const DEPARTMENT_CARD_WIDTH_PX = 360;

/** Shared surface styles for organization admin cards (company + department). */
export const adminOrganizationCardSurfaceSx: SystemStyleObject<Theme> = {
  bgcolor: "background.paper",
  borderRadius: "12px",
  border: theme => `0.5px solid ${theme.palette.divider}`,
  overflow: "hidden",
  boxShadow: "none",
  transition: "box-shadow 0.18s ease, border-color 0.18s ease",
  "&:hover": {
    borderColor: theme =>
      theme.palette.mode === "dark" ? theme.palette.grey[600] : theme.palette.grey[400],
    boxShadow: theme =>
      theme.palette.mode === "dark" ? "0 2px 14px rgba(0,0,0,0.35)" : "0 2px 14px rgba(0,0,0,0.08)"
  }
};

export function StyledCardRoot(props: CardProps) {
  return (
    <Card
      {...props}
      sx={{
        maxWidth: ADMIN_STYLED_CARD_WIDTH_PX,
        minWidth: ADMIN_STYLED_CARD_WIDTH_PX,
        marginRight: "10px",
        marginBottom: "10px",
        ...props.sx // allow overrides
      }}
    />
  );
}

export function StyledDepartmentCardRoot(props: CardProps) {
  return (
    <Card
      {...props}
      sx={{
        maxWidth: DEPARTMENT_CARD_WIDTH_PX,
        minWidth: DEPARTMENT_CARD_WIDTH_PX,
        width: DEPARTMENT_CARD_WIDTH_PX,
        marginRight: "10px",
        marginBottom: "10px",
        ...adminOrganizationCardSurfaceSx,
        ...props.sx
      }}
    />
  );
}

export function StyledCompanyCardRoot(props: CardProps) {
  return (
    <Card
      {...props}
      sx={{
        maxWidth: { xs: "95%", sm: 400 },
        minWidth: { xs: "95%", sm: 400 },
        marginRight: { xs: 0, sm: "10px" },
        marginBottom: "10px",
        ...adminOrganizationCardSurfaceSx,
        ...props.sx
      }}
    />
  );
}
